var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c("w-tabs", {
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.selectedTab,
              callback: function ($$v) {
                _vm.selectedTab = $$v
              },
              expression: "selectedTab",
            },
          }),
        ],
        1
      ),
      _vm.selectedTab == 0
        ? [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12", lg: "4", xl: "3" } },
                  [
                    _c(
                      "w-card",
                      { style: { flexGrow: 1 } },
                      [
                        _c("w-card-title", [_vm._v("Filters")]),
                        _c(
                          "w-card-content",
                          [
                            _c(
                              "w-row",
                              [
                                _c(
                                  "w-col",
                                  { attrs: { xs: "12" } },
                                  [
                                    _c("w-switch", {
                                      attrs: { label: "requests", space: "" },
                                      model: {
                                        value: _vm.filters.requests,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "requests", $$v)
                                        },
                                        expression: "filters.requests",
                                      },
                                    }),
                                    _c("w-switch", {
                                      attrs: { label: "pdfs", space: "" },
                                      model: {
                                        value: _vm.filters.pdfs,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "pdfs", $$v)
                                        },
                                        expression: "filters.pdfs",
                                      },
                                    }),
                                    _c("w-switch", {
                                      attrs: { label: "clients", space: "" },
                                      model: {
                                        value: _vm.filters.clients,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "clients", $$v)
                                        },
                                        expression: "filters.clients",
                                      },
                                    }),
                                    _c("w-switch", {
                                      attrs: {
                                        label: "running jobs",
                                        space: "",
                                      },
                                      model: {
                                        value: _vm.filters.runningJobs,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "runningJobs",
                                            $$v
                                          )
                                        },
                                        expression: "filters.runningJobs",
                                      },
                                    }),
                                    _c("w-switch", {
                                      attrs: {
                                        label: "queued jobs",
                                        space: "",
                                      },
                                      model: {
                                        value: _vm.filters.queuedJobs,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "queuedJobs",
                                            $$v
                                          )
                                        },
                                        expression: "filters.queuedJobs",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "12", lg: "8", xl: "9" } },
                  [
                    _c(
                      "w-card",
                      [
                        _c("w-card-title", [
                          _vm._v(
                            "Data / " +
                              _vm._s(_vm.metrics.interval) +
                              " seconds"
                          ),
                        ]),
                        _c(
                          "w-card-content",
                          [
                            _c("apexchart", {
                              ref: "chart",
                              attrs: {
                                type: "area",
                                height: 300,
                                series: _vm.initialSeries,
                                options: _vm.chartOptions,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [_c("app-running-job-list")],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [_c("app-active-users")],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm.selectedTab == 1
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [_c("app-demo-statistics")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.selectedTab == 2
        ? [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "6" } },
                  [
                    _c("app-server-dangling-dbs-list", { staticClass: "mb" }),
                    _c("app-queued-company-move-dbs"),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "6" } },
                  [_c("app-profiling-actions")],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.selectedTab == 3
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [_c("app-peppol-actions")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }